module.exports = __webpack_public_path__ + "static/img/video-placeholder.be599ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video-placeholder.jpg
// module id = 1732
// module chunks = 2